import "./text_btn.css"
import { Link } from "react-router-dom"

function TextBtn({ link, text, onClick }) {
    return (
        <Link to={link} className="MenuBtn" onClick={onClick}>{text}</Link >
    )
}

export default TextBtn